import { useTheme } from '@karnov/kui-react'

import { FC } from 'react'

import { DropdownMenuItem } from 'components/DropdownMenu'

import { useTranslation } from 'services/i18n'
import { Language, Country } from 'types/Api'

import { OnSelectOption } from './useLanguageAndCountrySelector'

type Props = {
  isSelected: boolean
  language: Language
  country: Country
  onSelect: OnSelectOption
}

export const LanguageOption: FC<Props> = ({ isSelected, language, country, onSelect }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_menu.language_selector',
  })

  const { isDarkMode } = useTheme()

  const highlightColor = isDarkMode ? 'bg-grey-70' : 'bg-yellow-60'

  return (
    <DropdownMenuItem
      className={isSelected ? highlightColor : ''}
      onClick={() => onSelect({ language, country })}
    >
      <div className="ml-1 mr-2 flex gap-2">
        {`${country.toUpperCase()}-${t(`languages.${language}`)}`}
      </div>
    </DropdownMenuItem>
  )
}
